import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Roles from './pages/Roles';
import Users from './pages/Users';
import AuditLogs from './pages/AuditLogs';
import Sessions from './pages/Sessions';
import Navbar from './components/Navbar';
// import Sidebar from './components/Sidebar';
import './App.css';

const AppLayout = ({ children }) => (
  <div>
    <Navbar />
    <div style={{ display: 'flex' }}>
        {children}
      </div>
    </div>
);

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />

        {/* Protected Routes (With Navbar and Sidebar) */}
        <Route
          path="/"
          element={
            <AppLayout>
              <Dashboard />
            </AppLayout>
          }
        />
        <Route
          path="/dashboard"
          element={
            <AppLayout>
              <Dashboard />
            </AppLayout>
          }
        />
        <Route
          path="/roles"
          element={
            <AppLayout>
              <Roles />
            </AppLayout>
          }
        />
        <Route
          path="/users"
          element={
            <AppLayout>
              <Users />
            </AppLayout>
          }
        />
        <Route
          path="/audit-logs"
          element={
            <AppLayout>
              <AuditLogs />
            </AppLayout>
          }
        />
        <Route
          path="/sessions"
          element={
            <AppLayout>
              <Sessions />
            </AppLayout>
          }
        />
        {/* Fallback */}
        <Route
          path="*"
          element={
            <AppLayout>
              <Dashboard />
            </AppLayout>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;